import React from 'react';
import { Link } from 'react-router-dom';

const Tools = () => {
  const otherTools = [
    {
      id: 'template-download',
      name: '手链设计模板下载',
      description: '提供PDF/AI格式的手链设计草图模板',
      icon: '📄',
      path: '/tools/template-download'
    },
    {
      id: 'custom-form',
      name: '手链定制表单',
      description: '收集用户定制需求，生成定制摘要',
      icon: '📋',
      path: '/tools/custom-form'
    },
    {
      id: 'qrcode-generator',
      name: '手链二维码生成',
      description: '输入手链信息，生成二维码',
      icon: '📱',
      path: '/tools/qrcode-generator'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-emerald-800">
          实用工具
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {otherTools.map((tool) => (
            <Link
              key={tool.id}
              to={tool.path}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-green-100"
            >
              <div className="text-4xl mb-4">{tool.icon}</div>
              <h2 className="text-xl font-semibold mb-2 text-emerald-700">
                {tool.name}
              </h2>
              <p className="text-gray-600">{tool.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tools;